import ErrorMessageNew from 'components/ErrorMessageNew';
import { ErrorBoundary as ReactErrorBoundry } from 'react-error-boundary';

const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  return (
    <ReactErrorBoundry
      fallbackRender={({ error }) => <ErrorMessageNew error={error instanceof Error ? error : null} />}
    >
      {children}
    </ReactErrorBoundry>
  );
};

export default ErrorBoundary;
